module.exports = __webpack_public_path__ + "img/brand_nav_gray.f32405e5.svg";